import TeamManagementData from './TeamManagementData';

export default TeamManagementData;
